/*
import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

//Components
import MainForm from '../components/MainForm/'

//Imgs
import mainCar from '../images/front-page/auto-blanco.png'

const LocationsEs = ({ data }) => (
  <div className="page locations-landing">
  <Helmet
            title={`Oficinas de Budget Nicaragua - Encuentra un alquiler de autos cerca de ti`}
            meta={[
              {
                name: 'description',
                content:
                  'Preguntas frecuentes sobre el alquiler de autos.',
              },
            ]}
            link={[
              {
                rel: 'alternate',
                hreflang: 'es',
                href:
                  './en/locations',
              },
            ]}
          />

    <iframe
      src="https://www.google.com/maps/d/embed?mid=1xDoLFdp8x-UM2Z7c2-cgNBb1I3I" 
      width="100%"
      height="450"
      frameborder="0"
      allowfullscreen
    />
    <h1>Ubicaciones</h1>

    <div class="grid-wrapper">
      <div className='item'>
        <h2 className="title city"><a href="/es/locations/oficina-central">
          Budget Oficina Central  </a>
        </h2>
        <p>Pista Juan Pablo Ii, Frente A Enel Central</p>
        <p className='phone_es'>Teléfono:<a href="tel:+50522559001">+505 2255-9001</a> </p>
        <p>Lunes a Domingo de 7:00 A.M. a 7:00 P.M.</p>
      </div>

      <div className='item'>
        <h2 className="title city"><a href="/en/locations/masaya-aeromundo">Budget Office Road Masaya Aeromundo</a></h2>
        <p>Aeromundo Camino De Oriente, Modulo A1</p>
        <p className='phone_es'>Teléfono:<a href="tel:+50522559003">+505 2255-9003</a></p>
        <p>Lunes a Domingo  7:00 A.M. a 7:00 P.M.</p>
      </div>

    
      <div className='item'>
        <h2 className="title airport"><a href="/es/locations/aeropuerto-augusto-sandino">
        Budget rent a car Aeropuerto Augusto Sandino.</a>
        </h2>
        <p>Aeropuerto Internacional De Nicaragua</p>
        <p className='phone_es'>Teléfono:<a href="tel:+50522559004">+505 2255-9004</a></p>
        <p>Lunes a Domingo 24 horas</p>
      </div>

      <div className='item'>
        <h2 className="title hotel"><a href="/es/locations/holiday-inn">Budget rent a car Hotel Holiday Inn Convention Center</a></h2>
        <p>Pista Juan Pablo II</p>
        <p className='phone_es'>Teléfono:<a href="tel:+50522559002">+505 2255-9002</a></p>
        <p>Lunes a Sabado de 8:00 A.M. a 5:00 P.M.</p>
        <p>Domingo de 8:00 A.M. a 12:00 P.M.</p>
      </div>

      <div className='item'>
        <h2 className="title city"><a href="/es/locations/granada">Budget Rent a car Granada</a></h2>
        <p>Calle Inmaculada,plaza Inmaculada Granada Nicaragua</p>
        <p className='phone_es'>Teléfono:<a href="tel:+50522559010">+505 2255-9010</a></p>
        <p>Lunes a Sabado de 8:00 A.M. a 5:00 P.M.</p>
        <p>Domingo de 8:00 A.M. a 12:00 P.M.</p>
      </div>


      <div className='item'>
        <h2 className="title hotel"><a href="/es/locations/san-juan-del-sur">Budget Rent a car San Juan del Sur, Hotel Victoriano</a></h2>
        <p>Hotel Victoriano, Boulevard De La Mar Rivas, 212 Ni</p>
        <p className='phone_es'>Teléfono:<a href="tel:+50522559015">+505 2255-9015</a></p>
        <p>Lunes a Sabado de 8:00 A.M. a 5:00 P.M.</p>
        <p>Domingo de 8:00 A.M. a 12:00 P.M.</p>
      </div>

      <div className='item'>
        <h2 className="title city"><a href="/es/locations/matagalpa">Budget Rent a car Matagalpa</a></h2>
        <p>Frente A Costado Noroeste De La Catedral Matagalpa Nicaragua</p>
        <p className='phone_es'>Teléfono:<a href="tel:+50522559016">+505 2255-9016</a></p>
        <p>Lunes a Sabado de 8:00 A.M. a 5:00 P.M.</p>
        <p>Domingo de 8:00 A.M. a 12:00 P.M.</p>
      </div>

       <div className='item'>
        <h2 className="title hotel"><a href="/es/locations/chinandega">Budget Rent a car Chinandega, Hotel Los Farallones</a></h2>
        <p>Hotel Los Farallones, Chinandega Nicaragua</p>
        <p className='phone_es'>Teléfono:<a href="tel:+50522559012">+505 2255-9012</a></p>
        <p>Lunes a Sabado de 8:00 A.M. a 5:00 P.M.</p>
        <p>Domingo de 8:00 A.M. a 12:00 P.M.</p>
      </div>



      <div className='item'>
        <h2 className="title city"><a href="/es/locations/fontana">Budget Oficina Villa Fontana</a></h2>
        <p>Super Mercado La Union, Villa Fontana.</p>
        <p className='phone_es'>Teléfono:<a href="tel:+50522559003">+505 2255-9003</a></p>
        <p>Lunes a Sabado de 7:00 A.M. a 7:00 P.M.</p>
        <p>Domingo de 7:00 A.M. a 7:00 P.M.</p>
      </div>


      <div className='item'>
        <h2 className="title city"><a href="/es/locations/larreynaga">Budget rent a car Larreynaga</a></h2>
        <p>Supermercado La Union Rotonda La Virgen 200 Metros Al Norte</p>
        <p className='phone_es'>Teléfono:<a href="tel:+50522559013">+505 2255-9013</a></p>
        <p>Lunes a Sabado de 7:00 A.M. a 7:00 P.M.</p>
        <p>Domingo de 7:00 A.M. a 7:00 P.M.</p>
      </div>


      <div className='item'>
        <h2 className="title city"><a href="/es/locations/carretera-masaya">Budget rent a car Carretera Carretera Km 12.</a></h2>
        <p>Km. 12 Carretera A Masaya</p>
        <p className='phone_es'>Teléfono:<a href="tel:+50522559014">+505 2255-9014</a></p>
        <p>Lunes a Sabado de 7:00 A.M. a 7:00 P.M.</p>
        <p>Domingo de 7:00 A.M. a 7:00 P.M.</p>
      </div>


      <div className='item'>
        <h2 className="title city"><a href="/es/locations/nejapa">Budget rent a car Nejapa</a></h2>
        <p>Encuentranos en Super Mercado La Union Nejapa.</p>
        <p className='phone_es'>Phone:<a href="tel:+50522559007">+505 2255-9007</a></p>
        <p>Monday - Saturday 7:00 A.M. a 7:00 P.M.</p>
        <p>Sunday 7:00 A.M. a 7:00 P.M.</p>
      </div>


      
    </div>
  </div>
)

export const query = graphql`
  query LocationsEsQuery {
    imageSharp(id: { regex: "/main-bg/" }) {
      sizes(maxWidth: 1600) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`

export default LocationsEs

*/


import React, { Component } from 'react'
import Img from 'gatsby-image'
import Modal from '../components/Fleet/FleetModal'
import axios from 'axios'
import { backendURL } from '../data/config.json'
import Helmet from 'react-helmet'




class LocationsEs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
    this.handleToogle = this.handleToogle.bind(this)
   /* this.renderItemsAirport = this.renderItemsAirport.bind(this)
    this.renderItemsHotel = this.renderItemsHotel.bind(this) */

    this.renderLocationsAirports = this.renderLocationsAirports.bind(this)
   //this.renderLocationsHotel = this.renderLocationsHotel.bind(this)
   // this.renderLocationsCities = this.renderLocationsCities.bind(this)

  }
  componentDidMount() {
    axios.get(`https://bkndnicaragua.miweb.cr:5004/api/locations`).then(res => {
      this.setState({
        loading: false, 
        locations: res.data,
      })
    })

    axios
        .get(`${backendURL}/api/banners/page/Locations`)
        .then(res => {
          const main = res.data.filter(data => data.section === 'Main')
          if (main[0]) {
            this.setState(prevState => {
              return {
                ...prevState,
                loading: false,
                mainImageEs: {
                  title: main[0].title.es,
                  url: main[0].imageEs,
                },
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    
  }

  handleToogle(e) {
    const { checked: value, id } = e.target
    this.setState({
      [id]: value,
    })
  }


/*  renderLocationsCities() {
        const { locations } = this.state
        return _.map(locations, (location, i) => {
          //const { langKey: lang } = this.props.pathContext
          const { title ,address ,phone, schedule, type, published } = location
    
          if (published && type == 'city') {
            const id = `location${i}`
            return (
                <div>
              <h2 className="title city" style={{color: "#ed5505"}} for={id}>{title.en}</h2>
              <p for={id}>{address.en}</p>
              <p className='phone_es' for={id}>Phone:{phone}</p>
              <p for={id}>{schedule.en}</p><br/>
                </div>


          )
      return null
    }
    })
  }*/


/*  renderLocationsHotel() {
    const { locations } = this.state
    return _.map(locations, (location, i) => {
      //const { langKey: lang } = this.props.pathContext
      const { title ,address ,phone, schedule, type, published } = location

      if (published && type == 'hotel') {
        const id = `location${i}`
        return (
            <div>
               <h2 className="title city" style={{color: "#ed5505"}} for={id}>{title.en}</h2>
              <p for={id}>{address.en}</p>
              <p className='phone_es' for={id}>Phone:{phone}</p>
              <p for={id}>{schedule.en}</p><br/>
            </div>


      )
  return null
}
})
}*/

renderLocationsAirports() {
  const { locations } = this.state
  return _.map(locations, (location, i) => {
    //const { langKey: lang } = this.props.pathContext
    const { title ,address ,phone, schedule, type, published } = location

    if (published && type == 'airport' || type == 'hotel' || type == 'city') {
      const id = `location${i}`
      return (
          <div className='item'>
            <h2 className={`item title ${type}`} style={{color: "#ed5505", fontWeight:"bold"}}for={id}>{title.es}</h2>
            <p for={id}>{address.es}</p>
            <ul style={{overflow:'auto', marginLeft:'0px' ,marginBottom:'0.5rem'}} >{_.map(phone, (item, i) => {

              let string_item = item.toString()

              let string_sin_espacio = string_item.replace(/\s/g, "")
              let string_phone = string_sin_espacio.replace('-', "")

                  return(
                  <li key={i} style={{whiteSpace: 'nowrap'}}>
                  Phone: <a href={`tel:${string_phone}`} >
                  {item}
                  </a>
                  </li>)
              })}
              </ul>
            <p for={id}>{schedule.es}</p>
          </div>


    )
return null
}
})
}

  render() {

    return (
      <div className="page loc locations-landing">

      <Helmet
          title={` Car Sales with Budget Guatemala`}
          meta={[
            {
              name: 'description',
              content:
                'Frequently Asked Questions about car rentals.',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'es',
              href: './es/alliances',
            },
          ]}
        />

        <div className="excerpt">
            <iframe
          src="https://www.google.com/maps/d/embed?mid=1xDoLFdp8x-UM2Z7c2-cgNBb1I3I" 
          width="100%"
          height="450"
          frameborder="0"
          allowfullscreen
        />

          <div className="content">
          <center><h1>Ubicaciones</h1></center>
          <div class="grid-wrapper"> 
          {this.renderLocationsAirports()}
          </div>

        </div>
      </div>
      </div>
    )

  }
}

export const query = graphql`
  query LocationsEs {
    imageSharp(id: { regex: "/deals-top-background/" }) {
      sizes(maxWidth: 1600) {
        ...GatsbyImageSharpSizes
      }
    }
  }
`
export default LocationsEs



// WEBPACK FOOTER //
// ./src/pages/locations.es.js